const rand = () => Math.random() + 1;
// current       start         stop         speed
// x,  y,  r
export const circles = 
[[[27, 45, 20], [27, 45, 20], [27, 50, 25], 1],
 [[27, 45, 15], [27, 45, 15], [27, 55, 15], 1],
 [[27, 45, 20], [27, 45, 20], [27, 61, 25], 1],
 [[34, 50, 17], [34, 50, 17], [34, 58, 17], rand()],
 [[40, 50, 21], [40, 50, 21], [40, 60, 21], rand()],
 [[45, 50, 16], [45, 50, 16], [45, 55, 16], rand()],
 [[51, 50, 25], [51, 50, 25], [51, 60, 25], rand()],
 [[58, 50, 20], [58, 50, 20], [58, 60, 20], rand()],
 [[66, 50, 20], [66, 50, 20], [66, 58, 20], rand()],
 [[71, 45, 18], [71, 45, 18], [71, 52, 18], 1],
 [[71, 45, 23], [71, 45, 23], [71, 60, 23], 1],
 [[71, 45, 20], [71, 45, 20], [71, 68, 22], 1]];


// current       start         stop
// x,  y,  r
export const splats = 
[[[30, 35, 25], [30, 35, 25], [27, 30, 25]],
 [[30, 35, 25], [30, 35, 25], [23, 23, 25]],
 [[30, 35, 20], [30, 35, 20], [19, 17, 20]],
 [[30, 35, 25], [30, 35, 25], [15, 10, 25]],
 [[35, 35, 21], [35, 35, 21], [35, 24, 21]],
 [[35, 35, 18], [35, 35, 18], [37, 28, 18]],
 [[35, 35, 21], [35, 35, 21], [31, 16, 21]],
 [[35, 35, 15], [35, 35, 15], [29, 13, 15]],
 [[35, 35, 18], [35, 35, 18], [27, 9, 18]],
 [[45, 35, 20], [45, 35, 20], [45, 28, 20]],
 [[45, 35, 23], [45, 35, 23], [44, 19, 23]],
 [[45, 35, 18], [45, 35, 18], [43, 11, 18]],
 [[45, 35, 20], [45, 35, 20], [42, 4, 20]],
 [[51, 35, 19], [51, 35, 19], [51, 28, 19]],
 [[51, 35, 15], [51, 35, 15], [51, 22, 15]],
 [[51, 35, 22], [51, 35, 22], [51, 15, 22]],
 [[51, 35, 9], [51, 35, 9], [51, 10, 9]],
 [[51, 35, 24], [51, 35, 24], [51, 5, 24]],
 [[58, 35, 14], [58, 35, 14], [58, 28, 14]],
 [[58, 35, 19], [58, 35, 19], [59, 22, 19]],
 [[58, 35, 18], [58, 35, 18], [60, 15, 18]],
 [[58, 35, 18], [58, 35, 18], [61, 10, 18]],
 [[66, 35, 20], [66, 35, 20], [66, 28, 20]],
 [[66, 35, 20], [66, 35, 20], [67, 22, 20]],
 [[66, 35, 15], [66, 35, 15], [69, 15, 15]],
 [[66, 35, 20], [66, 35, 20], [70, 10, 20]],
 [[66, 35, 20], [66, 35, 20], [72, 5, 20]],
 [[70, 35, 20], [70, 35, 20], [73, 28, 20]],
 [[70, 35, 15], [70, 35, 15], [76, 23, 15]],
 [[70, 35, 25], [70, 35, 25], [79, 19, 25]],
 [[70, 35, 10], [70, 35, 10], [81, 16, 10]],
 [[70, 35, 20], [70, 35, 20], [83, 13, 20]],
 [[70, 35, 20], [70, 35, 20], [76, 33, 20]],
 [[70, 35, 17], [70, 35, 17], [80, 30, 17]],
 [[70, 35, 25], [70, 35, 25], [83, 27, 25]],
 [[70, 35, 20], [70, 35, 20], [87, 24, 20]],
 [[70, 35, 27], [70, 35, 27], [90, 21, 27]],
 [[70, 35, 20], [70, 35, 20], [92, 19, 20]],
 [[70, 41, 20], [70, 41, 20], [75, 41, 20]],
 [[70, 41, 25], [70, 41, 25], [78, 41, 25]],
 [[70, 41, 25], [70, 41, 25], [85, 41, 25]],
 [[70, 41, 30], [70, 41, 30], [88, 41, 30]],
 [[70, 51, 20], [70, 51, 20], [73, 51, 20]],
 [[70, 51, 23], [70, 51, 23], [78, 55, 23]],
 [[70, 51, 15], [70, 51, 15], [81, 58, 15]],
 [[70, 51, 24], [70, 51, 24], [83, 60, 24]],
 [[70, 51, 25], [70, 51, 25], [89, 65, 25]],
 [[65, 50, 15], [65, 50, 15], [65, 55, 15]],
 [[65, 50, 24], [65, 50, 24], [66, 62, 24]],
 [[65, 50, 20], [65, 50, 20], [67, 65, 20]],
 [[65, 50, 20], [65, 50, 20], [68, 70, 20]],
 [[65, 50, 30], [65, 50, 30], [70, 80, 30]],
 [[58, 50, 20], [58, 50, 20], [58, 55, 20]],
 [[58, 50, 23], [58, 50, 23], [58, 65, 23]],
 [[58, 50, 20], [58, 50, 20], [59, 70, 20]],
 [[58, 50, 27], [58, 50, 27], [59, 80, 27]],
 [[58, 50, 27], [58, 50, 27], [60, 90, 24]],
 [[49, 50, 20], [49, 50, 20], [49, 58, 20]],
 [[49, 50, 20], [49, 50, 20], [49, 68, 20]],
 [[49, 50, 24], [49, 50, 24], [49, 73, 24]],
 [[49, 50, 18], [49, 50, 18], [49, 80, 18]],
 [[49, 50, 25], [49, 50, 25], [49, 89, 25]],
 [[49, 50, 20], [49, 50, 20], [49, 93, 20]],
 [[44, 50, 20], [44, 50, 20], [44, 55, 20]],
 [[44, 50, 16], [44, 50, 16], [44, 62, 16]],
 [[44, 50, 24], [44, 50, 24], [43, 70, 24]],
 [[44, 50, 16], [44, 50, 16], [42, 75, 16]],
 [[44, 50, 25], [44, 50, 25], [42, 86, 33]],
 [[37, 50, 20], [37, 50, 20], [37, 53, 20]],
 [[37, 50, 20], [37, 50, 20], [36, 60, 20]],
 [[37, 50, 20], [37, 50, 20], [35, 65, 20]],
 [[37, 50, 26], [37, 50, 26], [34, 69, 26]],
 [[37, 50, 25], [37, 50, 25], [31, 81, 28]],
 [[30, 50, 20], [30, 50, 20], [27, 55, 20]],
 [[30, 50, 20], [30, 50, 20], [23, 60, 20]],
 [[30, 50, 30], [30, 50, 30], [19, 64, 30]],
 [[30, 50, 30], [30, 50, 30], [14, 70, 30]],
 [[30, 45, 30], [30, 45, 30], [24, 45, 30]],
 [[30, 45, 20], [30, 45, 20], [18, 45, 20]],
 [[30, 45, 12], [30, 45, 12], [15, 45, 12]],
 [[30, 45, 25], [30, 45, 25], [12, 45, 25]],
 [[30, 45, 20], [30, 45, 20], [8, 45, 20]]];
